const createAnimationSelectedAnimationTypeSelector = (
    state: sage.state.IRedux
): sage.model.AnimationType | null => {
    return state.createAnimation.selectedAnimationType;
};

export default createAnimationSelectedAnimationTypeSelector;
